import { z } from "zod";

export const marketingEventSchema = z.object({
  event_name: z.enum(["PaymentGenerated", "Purchase"]),
  event_id: z.string().min(1).max(128),
  value_cents: z.number().int().nonnegative(),
  currency: z.literal("BRL"),
  content_ids: z.array(z.string().min(1).max(128)).max(100),
  payment_method: z.enum(["pix", "card", "boleto"]),
}).strict();

export type MarketingEvent = z.infer<typeof marketingEventSchema>;
